import axios from "axios";

/**
 * The raw HTTP call the local-server ("master device") sync makes, lifted out of BOTH apps'
 * `saga/localServer/localServer.js`.
 *
 * ⚠️ Only the axios call moved. The sagas themselves stay in the apps — sagas are a LATER phase
 * than helpers (ledger: `slices -> helpers -> stores -> sagas`), and their generator wiring plus
 * the divergent error handling around this call is app-side. What moved is the part that made
 * those files import axios directly.
 *
 * The two apps' calls were byte-identical apart from quote style, so this is genuinely shared.
 * What DIFFERS, and therefore stayed behind in each saga:
 *   - web shows `ToastNotifyError(pos_errormap[response.code])` on an error code and
 *     `ToastNotifyError(error)` on a throw;
 *   - mobile has BOTH of those commented out, along with its `pos_errormap` import.
 * That divergence is real (mobile silently swallows local-server errors), so it is preserved
 * rather than unified — see the ledger.
 *
 * ⚠️ Talks to a LAN peer over plain `http://` on port 6888, not to the Rista API, so it
 * deliberately does NOT go through `utils/apiService`: no ATOKEN, no base URL, no interceptors.
 * The payload is form-urlencoded as a single URI-encoded JSON blob, which is what the master
 * device's server expects — do not "modernise" it to a JSON body.
 */
export function postToLocalServerMaster({
  serverAddress,
  path,
  deviceIdentifier,
  message,
}: {
  serverAddress: string;
  path: string;
  deviceIdentifier: any;
  message: any;
}) {
  const params = {
    deviceIdentifier,
    message,
  };
  const data = encodeURIComponent(JSON.stringify(params));
  return axios({
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "Referrer-Policy": "no-referrer",
    },
    data: data,
    url: `http://${serverAddress}:6888/${path}`,
  });
}
